module.exports = __webpack_public_path__ + "img/icon-pick-at-store-type.bfb822f9.svg";